export default __webpack_public_path__ + "static/media/students-dashboard.6714b824.svg";